import styled from 'styled-components';
import { Card } from 'antd';


export const InfoCard = styled(Card)`
    border-radius: 10px!important;
    width: 24.5%!important;
    box-shadow: 2px 2px 5px 0px #ddd!important;
`;